var React = require('react');

function Nav (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5 2.5h41.62M2.5 16.469h41.62M2.5 30.438h41.62"}));
}

Nav.defaultProps = {"viewBox":"0 0 46.62 32.938","strokeLinecap":"round","strokeWidth":"5"};

module.exports = Nav;

Nav.default = Nav;
